module.exports = __webpack_public_path__ + "img/color.8b228e3b.svg";